module.exports = __webpack_public_path__ + "img/logo.69e46d90.svg";